/* ------------------------------------------------------------------------------
@name: Projects
@description: Projects – toggle search dan modal
--------------------------------------------------------------------------------- */

const Projects = (() => {
  const $project = $('.project');

  const bindSearchToggle = () => {
    // Buka mode pencarian
    $project.on('click', '.project__card__button', () => {
      $('body').addClass('search-active');
    });

    // Tutup mode pencarian
    $project.on('click', '.js-project-close', () => {
      $('body').removeClass('search-active');
    });

    // Escape untuk tutup pencarian
    $(document).on('keydown', (e) => {
      if (e.key === 'Escape' && $('body').hasClass('search-active')) {
        $('body').removeClass('search-active');
      }
    });
  };

  const init = () => {
    bindSearchToggle();
  };

  return { init };
})();

export default Projects;
